export const SHARE_TARGET_PATH = '/share-target'
export const SHARE_TARGET_METHOD = 'POST'
export const SHARE_TARGET_ENCTYPE = 'multipart/form-data'
export const SHARE_TARGET_FILE_FIELD = 'photos'
export const SHARE_TARGET_ACCEPT = ['image/*', '.heic', '.heif'] as const
export const SHARE_INBOX_QUERY_PARAM = 'share-inbox'
export const SHARE_INBOX_QUERY_VALUE = '1'

export function validateShareTargetConfiguration(): void {
  if (!SHARE_TARGET_PATH.startsWith('/') || SHARE_TARGET_PATH.includes('?') || SHARE_TARGET_PATH.includes('#')) {
    throw new Error('Share Target path must be an absolute path without a query or fragment')
  }
  if (!SHARE_TARGET_FILE_FIELD.trim()) throw new Error('Share Target file field must not be empty')
  if (new Set(SHARE_TARGET_ACCEPT).size !== SHARE_TARGET_ACCEPT.length) {
    throw new Error('Share Target accepted file patterns must be unique')
  }
  if (SHARE_TARGET_ACCEPT.some((pattern) => !pattern.trim())) {
    throw new Error('Share Target accepted file patterns must not be empty')
  }
  if (!SHARE_INBOX_QUERY_PARAM.trim() || !SHARE_INBOX_QUERY_VALUE.trim()) {
    throw new Error('Share Inbox launch query must have a non-empty name and value')
  }
}
